import { gql, type OperationVariables } from '@apollo/client';
import GraphQL from '../graphQL';

export interface IADGroup {
    id: string;
    displayName: string;
}

const query = gql`
query {
    adGroups {
        id
        displayName
    }
}
`;

export default async function getAdGroups(): Promise<IADGroup[]> {
    const variables: OperationVariables = {};
    return GraphQL.query<{ adGroups: IADGroup[] }>(query, variables).then((obj) => obj?.adGroups ?? []);
}
